<div class="left-aside">
  <div
    [ngClass]="{ opened: visible }"
    class="left-aside__content"
  >
    <ng-content></ng-content>
  </div>

  <button
    type="button"
    class="left-aside__switch"
    (click)="change()"
  >
    <med-icon-expand
      class="left-aside__icon"
      [ngClass]="{ rotate: !visible }"
      size="16"
    ></med-icon-expand>
  </button>
</div>
